import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment Topic on essay_topics {
    id
    created_at
    user_id
    idea
    impact
    outcome
    type
    like
    ease
  }
  fragment Prompt on essay_prompts {
    id
    created_at
    idea
    action
    result
    situation
    task
    user_id
    topic_id
    category_id
  }
  fragment Statement on personal_statements {
    id
    created_at
    name
    due_date
    draft_due_date
    prompt_id
    topic_id
    user_id
    status
    essay_topic {
      ...Topic
    }
    documents {
      ...StatementDocument
    }
    schools
  }
  fragment StatementDocument on personal_statements_documents {
    id
    personal_statements_id
    document_id
    document {
      id
      url
      filename
      status
    }
  }
`;

export const GET_ESSAY_TOPICS = gql`
  query getTopics($userId: Int) {
    essay_topics(
      where: { user_id: { _eq: $userId } }
      order_by: [{ idea: asc }]
    ) {
      ...Topic
    }
  }
  ${FRAGMENTS}
`;

export const GET_ESSAY_PROMPTS = gql`
  query getPrompts($userId: Int) {
    essay_prompts(
      where: { user_id: { _eq: $userId } }
      order_by: [{ idea: asc }]
    ) {
      ...Prompt
    }
  }
  ${FRAGMENTS}
`;

export const ADD_TOPIC = gql`
  mutation addTopic($data: essay_topics_insert_input!) {
    row: insert_essay_topics_one(object: $data) {
      ...Topic
    }
  }
  ${FRAGMENTS}
`;

export const ADD_PROMPT = gql`
  mutation addPrompt($data: essay_prompts_insert_input!) {
    row: insert_essay_prompts_one(object: $data) {
      ...Prompt
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_PROMPT = gql`
  mutation updatePrompt($id: Int!, $input: essay_prompts_set_input!) {
    row: update_essay_prompts_by_pk(pk_columns: { id: $id }, _set: $input) {
      ...Prompt
    }
  }
  ${FRAGMENTS}
`;

export const EDIT_TOPIC = gql`
  mutation updateTopic($id: Int!, $data: essay_topics_set_input) {
    row: update_essay_topics_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Topic
    }
  }
  ${FRAGMENTS}
`;

export const EDIT_PROMPT = gql`
  mutation updatePrompt($id: Int!, $data: essay_prompts_set_input) {
    row: update_essay_prompts_by_pk(pk_columns: { id: $id }, _set: $data) {
      ...Prompt
    }
  }
  ${FRAGMENTS}
`;

export const DELETE_TOPIC = gql`
  mutation deleteTopic($id: Int!) {
    delete_essay_topics(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const DELETE_PROMPT = gql`
  mutation deletePrompt($id: Int!) {
    delete_essay_prompts_by_pk(id: $id) {
      id
    }
  }
`;

export const GET_STATEMENTS = gql`
  query getStatements($userId: Int) {
    rows: personal_statements(
      where: { user_id: { _eq: $userId } }
      order_by: [{ name: asc }]
    ) {
      ...Statement
    }
  }
  ${FRAGMENTS}
`;

export const GET_UPCOMING_DRAFT_STATEMENTS = gql`
  query getUpcomingDraftStatements($userId: Int) {
    rows: personal_statements(
      where: {
        user_id: { _eq: $userId }
        status: { _eq: "draft" }
        draft_due_date: { _is_null: false }
        documents: { document_id: { _is_null: false } }
      }
      order_by: [{ name: asc }]
    ) {
      ...Statement
    }
  }
  ${FRAGMENTS}
`;

export const ADD_STATEMENT = gql`
  mutation addStatement($data: personal_statements_insert_input!) {
    row: insert_personal_statements_one(object: $data) {
      ...Statement
    }
  }
  ${FRAGMENTS}
`;

export const UPDATE_STATEMENT = gql`
  mutation updateStatement($id: Int!, $data: personal_statements_set_input) {
    row: update_personal_statements_by_pk(
      pk_columns: { id: $id }
      _set: $data
    ) {
      ...Statement
    }
  }
  ${FRAGMENTS}
`;

export const DELETE_STATEMENT = gql`
  mutation deleteStatement($id: Int!) {
    delete_personal_statements_by_pk(id: $id) {
      id
    }
  }
`;

export const ADD_PERSONAL_STATEMENT_ESSAY = gql`
  mutation addDoc($data: personal_statements_documents_insert_input!) {
    row: insert_personal_statements_documents_one(object: $data) {
      ...StatementDocument
    }
  }
  ${FRAGMENTS}
`;

export const LISTEN_ESSAY_CREDITS = gql`
  subscription listenCredits($userId: Int!) {
    credits: v_meeting_credits(
      where: {
        user_id: { _eq: $userId }
        credit_type: { _in: ["cc_essay", "hc_essay", "expert", "colleges"] }
      }
    ) {
      available
      credit
      debit
      user_id
      credit_type
    }
  }
`;

export const GET_ESSAYS_WITH_STATUS = gql`
  query getEssaysWithStatus($status: String) {
    rows: personal_statements(where: { status: { _eq: $status } }) {
      id
      name
      user_id
      user {
        name
          
      }
    }
  }
`;
